module.exports = __webpack_public_path__ + "pc/img/rec_03.9cabee5a.svg";